import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import UserPass from "../passes/UserPass";
import UserClass from "../classes/UserClass";

const UserClassesToPassModal = (props) => {
    const { t } = useTranslation();
    const { onClose, pass } = props;
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const getUserClasses2Pass = async () => {
        console.log(`upID: ${pass.up_id}, userID: ${pass.user_id}`);
        const res = await postMethod("/get-user-classes-to-pass", { upID: pass.up_id, userID: pass.user_id });
        if (checkServerData(res)) {
            const list = res.data.list.sort((a, b) => {
                if (new Date(a.class_start_time) > new Date(b.class_start_time)) return -1;
                else return 1;
            });
            setList(list);
        }
        setLoading(false);
    };

    useEffect(() => {
        //console.log(pass.user_id);
        getUserClasses2Pass();
        // eslint-disable-next-line
    }, []);

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("classes.classes2Pass")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        {loading ? (
                            <Col xs={12} className="my-4 text-center">
                                <p className="h5">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : (
                            <Fragment>
                                <Col xs={12} className="border shadow-sm rounded px-0">
                                    <Table className="white-table mb-0" borderless>
                                        <tbody>
                                            <UserPass pass={pass} i={0} onlyDisplay />
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col xs={12}>
                                    <p className="fs-5 my-3">{t("classes.assignedClasses")}</p>
                                </Col>
                                <Col xs={12} className="px-0">
                                    <Table className="white-table mb-0">
                                        <tbody>
                                            {list.map((e, i) => (
                                                <Fragment key={i}>
                                                    <UserClass c={e} onlyDisplay />
                                                </Fragment>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Fragment>
                        )}
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onClose}>
                    {t("close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserClassesToPassModal;
